<template>
  <div>
    <div id="canvasBox"></div>
    <div class="banner" id="banner" v-if="ipDataPage&&ipDataPage.length>0&&ipDataPage[0].contents&&ipDataPage[0].contents.length>0">
      <img :src="lang == 'zh' ? ipDataPage[0].contents[0].picturesZhCn : (ipDataPage[0].contents[0].picturesEnUs ? ipDataPage[0].contents[0].picturesEnUs : ipDataPage[0].contents[0].picturesZhCn )" id="img">
      <div v-html="lang == 'zh' ? ipDataPage[0].contents[0].contentZhCn : (ipDataPage[0].contents[0].contentEnUs ? ipDataPage[0].contents[0].contentEnUs : ipDataPage[0].contents[0].contentZhCn)" class="bannerRichText"></div>
    </div>
    
      
    <!-- <v-container style="margin-bottom:20px">
        <v-row :class="$vuetify.breakpoint.mobile ? 'mobileIpBox main-box ip-box':'main-box ip-box'">
          <div class="main-header">
            <h1>{{$t('ip.ipNewsTitle')}}</h1>
            <span></span>
          </div>
          <v-carousel
              cycle
              hide-delimiter-background
              :hide-delimiters="true"
              @change="newsCarouselChange"
              :show-arrows="false"
              height="100%"
              cover
            >
              <v-carousel-item 
                v-for="(item, i) in newsList" 
                :key="i"
                :src="(lang == 'zh'?item.picturesZhCn: ( item.picturesEnUs ? item.picturesEnUs : item.picturesZhCn ))"
                cover
              >
                <div class="carousel-slot" :class="$vuetify.breakpoint.mobile ? 'mobileNewsSlot':''" @click="newsJump(item)">
                  <h3>{{ lang == 'zh' ? item.contentNameZhCn : (item.contentNameEnUs ? item.contentNameEnUs : item.contentNameZhCn) }}</h3>
                  <br/>
                  <div v-html="lang == 'zh' ? item.contentZhCn : (item.contentEnUs ? item.contentEnUs : item.contentZhCn)" class="newsRichText"></div>
                  <span @click="newsJump(item)">查看更多 <v-icon color="red">mdi-chevron-right</v-icon></span>
                </div>
              </v-carousel-item>
              <div class="footerCircle">
                <div v-for="(item, i) in newsList" :key="i" :class="i==carouselNewsIndex ? 'circle newActive' :'circle'"></div>
              </div>
            </v-carousel>
        </v-row>
        <v-row class="main-box">
          <div class="main-header">
            <h1>{{ lang == 'zh' ? 'SNS平台' : 'SNS'}}</h1>
            <span></span>
          </div>
          <div class="sns-info">
            <div v-for="(item,index) in snsList" :key="index">
              <img :src="lang == 'zh'? item.picturesZhCn : (item.picturesEnUs ? item.picturesEnUs : item.picturesZhCn)">
              <span>{{lang == 'zh'? item.contentNameZhCn : (item.contentNameEnUs ? item.contentNameEnUs : item.contentNameZhCn) }}</span>
            </div>
          </div>
        </v-row>
    </v-container> -->
  </div>
</template>

<script>
  import ipApi from '../../api/ip'
  export default {
    name: 'ip',

    data: () => ({
      carouselNewsIndex:'',
      ipDataPage: [],
      newsList: [],
      snsList: []
    }),
    computed:{
        //获取当前语言
        lang() {
            return this.$i18n.locale;
        },
    },
    watch:{
      '$route.query.sectionCode'(val){
        location.reload();
      }
    },
    mounted(){
      
      this.getData();
      let timer = setInterval(() => {
        if( document.getElementById('img') != null ) {
          clearInterval(timer);
          this.getImgColor();
        }
      }, 100);
    },
    methods:{
      //提取图片主题色
      getImgColor(){
        const oImg = document.getElementById('img');
        oImg.src = oImg.src + '?' + new Date().getTime();
        oImg.crossOrigin = 'Annoymous'
        oImg.onload = function(){
          //获取图片的宽高
          var img_url = this.src
          // 创建对象
          var img = new Image()
          // 改变图片的src
          img.src = img_url
          const w = img.width || this.width;
          const h = img.height || this.height;
          // 创建画布
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          // 绘制图片在画布上
          const context = canvas.getContext('2d');
          context.drawImage(this, 0, 0);
          let pxArr = context.getImageData(0, 0, w, h).data;
          pxArr = Array.from(pxArr);
          const colorList = {}
          let i = 0;
          while (i < pxArr.length) {
            const r = pxArr[i];
            const g = pxArr[i + 1];
            const b = pxArr[i + 2];
            const a = pxArr[i + 3];
            i = i + 4; // 最后 +4 比每次 i++ 快 10ms 左右性能
            const key = [r,g,b,a].join(',')
            key in colorList ? ++colorList[key] : (colorList[key] = 1)
          }
          let arr = [];
          for(let key in colorList){
            arr.push({
              rgba: `rgba(${key})`,
              num: colorList[key]
            })
          }
          arr = arr.sort((a,b) => b.num - a.num);
          let banner = document.getElementById('banner');

          //最小高度赋值
          let ww = img.height/document.body.clientWidth;
          let hh = img.height/ww;
          banner.style = `min-height:${hh}px`
          banner.style.backgroundColor  = arr[0].rgba;
        }
        oImg.onload();
      },
      newsCarouselChange(e){
        this.carouselNewsIndex = e;
      },
      //新闻跳转
      newsJump(item){
        this.$router.push({ path: '/newsDetail', query: { id: item.contentId }})
      },
      async getData(){
        let { data: ipData } = await ipApi.getIpList();
        let ipDataList = ipData[0];
        ipDataList.children.forEach(item => {
          if( item.sectionCode === this.$route.query.sectionCode ){
            this.ipDataPage = item.children.length>0 ? item.children : [];
            this.ipDataPage[0].contents[0].contentZhCn = this.ipDataPage[0].contents[0].contentZhCn ? this.ipDataPage[0].contents[0].contentZhCn.replace(/\<img/gi,'<img style="width:80%;height:auto" ') : this.ipDataPage[0].contents[0].contentZhCn;
            this.ipDataPage[0].contents[0].contentEnUs = this.ipDataPage[0].contents[0].contentEnUs ? this.ipDataPage[0].contents[0].contentEnUs.replace(/\<img/gi,'<img style="width:80%;height:auto" ') : this.ipDataPage[0].contents[0].contentEnUs;
          
            // let bannerRef = document.querySelector('.bannerRichText');
            // if( (this.lang == 'zh' && this.ipDataPage[0].contents[0].contentZhCn == null)
            //   ||
            //   ( this.lang == 'en' && this.ipDataPage[0].contents[0].contentEnUs == null )
            // ){
            //   bannerRef.style = "transform: translateY(-30%);margin-top:0";
            // }
          }
        });
      }
    },
    created(){
      this.getData()
    },
  }
</script>
<style lang="scss" scoped>
.banner{
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  img{
    width: 100%;
    display: block;
  }
  .bannerRichText{
    text-align: center;
    margin-top: -58%;
    // transform: translateY(-30%);
  }
}

.main-box{
  width: 80%;
  margin-left: 10%;
  .main-header{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    margin-top: 20px;
    span{
      width: 50px;
      height: 3px;
      background: red;
    }
  }
}
.mobileIpBox{
  height: 100%!important;
  :v-deep .v-image__image--cover{
    background-size: 100% 100%;
  }
  min-height: 60rem!important;
}
.ip-box{
  position: relative;
  margin-top: 10px;
  height: 420px;
  min-height: 420px;
  overflow: hidden;
  ::v-deep .v-image__image--cover{
    background-size: 100% 100%;
  }
  .mobileNewsSlot{
    font-size: 2rem;
    h3{
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-ovoverflow: ellipsis;
    }
    div{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    
  }
  .carousel-slot{
    position: absolute;
    height: 100%;
    right: 0;
    width: 100%;
    background: url('../../assets/images/main/news-bg.png');
    padding: 20px 10px;
    padding-left: 60%;
    div{
      margin-top: 20px;
    }
    span{
      color: red;
      display: flex;
      align-items: center;
      margin-top: 20px;
      cursor: pointer;
      ::v-deep .v-icon{
        font-size: 22px!important;
        transform: rotateX(45deg);
      }
    }
  }
  .newsRichText{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 9;
    overflow: hidden;
  }
  .footerCircle{
    height: 30px;
    position: absolute;
    right: 20px;
    bottom: 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .circle{
      width: 7px;
      height: 7px;
      margin-right: 3px;
      border-radius: 50%;
      background: #fff;
    }
    .newActive{
      border-radius: 30px;
      width: 20px;
      background: red;
      margin-top: 2px;
    }
  }
}
.sns-info{
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  img{
    width: 120px;
    height: 120px;
    border-radius: 20px;
  }
  div{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>
